import { useEffect, useState } from "react";

import { get_product_state } from "../utils/FeedInterface";
import ProductStruct from "../utils/ProductStruct";

export default function useProducts (  )
{
  const [ products, set_current_products ] = useState([  ]);
  const [ error, set_error ] = useState({  });
  const [ loading, set_loading ] = useState( true );




  // HOOKS ::::::::::::::::

  useEffect(() => {
    set_loading( true );
    get_products();
  }, [  ] );

  return { products, error, loading };




  // FUNZIONI :::::::::::::

  function get_products ( )
  {
    get_product_state( ).then( re => {

      // console.log( 'setting current products HOOK :: ', re );
      set_current_products( re ); // set return products.
      // set products data and store struct
      ProductStruct( re );

    }).catch( err => {
      set_error( err );

    }).finally(() => {

      set_loading( false );
    });
  }

}
